<template>
  <div
    class="flex flex-col items-center pointer-events-none rounded-sm bg-linen border border-sienna-muted p-4 lg:px-8 max-w-64"
    :class="{ group: !isDisabled }"
  >
    <div class="relative w-full">
      <button
        class="relative w-full flex justify-center items-center pointer-events-auto"
        :class="{ 'opacity-30': isDisabled }"
        :disabled="isDisabled"
        @click="goToMenu"
      >
        <PastaTypeIcon :type="type" class="size-16 shrink-0 text-burnt-sienna" />
      </button>
      <div
        class="flex flex-col items-center pt-2 pointer-events-none short:pt-2 2xl:py-4 h-fit"
        :class="{ 'justify-center': !isDisabled, 'mt-0': isDisabled }"
      >
        <div class="mb-2 md:mb-6 lg:mb-8">
          <p
            class="text-2xl text-center short:text-2xl md:text-3xl font-brand whitespace-nowrap"
            :class="{
              'text-brown-grey': isDisabled,
              'text-terracota-dark': !isDisabled,
            }"
            v-html="label"
          />
          <p
            class="text-sm md:text-base text-center max-w-[400px] transition-all duration-500 ease-in-out h-12 font-normal not-italic"
            :class="{
              'text-brown-grey': isDisabled,
              'text-burnt-sienna group-hover:text-terracota-dark': !isDisabled,
            }"
            v-html="text"
          />
        </div>
        <button :class="buttonStyle" :disabled="isDisabled" @click="goToMenu">
          <BaseLoadingIcon v-if="isLoading" class="size-6" />
          <span v-else>{{ btnText || 'Order now' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { twMerge } from 'tailwind-merge';

  interface Props {
    label: string;
    text: string;
    type: 'delivery' | 'pickup' | 'eat-in' | 'recipe-kits';
    isDisabled?: boolean;
    isLoading?: boolean;
    btnText?: string;
  }

  interface Emits {
    (e: 'clicked'): void;
  }

  const props = withDefaults(defineProps<Props>(), { btnText: '' });
  const emits = defineEmits<Emits>();

  const goToMenu = () => {
    if (!props.isDisabled) emits('clicked');
  };

  const buttonStyle = computed(() => {
    if (props.isDisabled)
      return 'w-full px-6 py-3 md:py-4 z-10 rounded-sm text-brown-grey bg-dusky-grey pointer-events-auto whitespace-nowrap font-nornmal not-italic';
    return twMerge(
      'primary-cta whitespace-nowrap',
      'group-hover:bg-cavolo-green transition-all duration-500 ease-in-out px-0 py-3 md:py-4 z-10 mt-0 pointer-events-auto font-normal not-italic'
    );
  });
</script>
